import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Card, GeneralInfo, DataWrapper, TableExt, CloseCardButton, Loader2, PageWrapper, Headline } from 'libs/ui';
import { getTableParams } from 'grids/client/grid.params';

export const Loading = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const closeCard = () => {
    history.goBack();
  };

  const tableParams = getTableParams(false, t);

  return (
    <PageWrapper>
      <Headline>
        <p>{t('cards.Карточка клиента')}</p>
        <CloseCardButton close={closeCard} />
      </Headline>
      <TableExt rows={{ count: 0, items: [] }} {...tableParams} refresh={null} />
      <Card>
        <Loader2 />
        <GeneralInfo />
        <DataWrapper />
      </Card>
    </PageWrapper>
  );
};
